import axios from "axios";
import { showToast } from "../helper/toastHelper";
import { LABEL } from "./constant";
import { cssTransition, toast, ToastContainer, Zoom } from "react-toastify";
import {
  decryptData,
  decryptJsonDataNode,
  decryptJsonDataPython,
  encryptData,
  encryptJsonDataNode,
  encryptJsonDataPython,
} from "./common";

export function CallAPI(
  end_point,
  method,
  apiUrl,
  body = "",
  isFile,
  showDefaultError = true,
) {
  const isSuccessfulHttpResponse = (response) =>
    response?.status >= 200 && response?.status < 300;
  const hasExplicitFailurePayload = (response) => {
    const payload = response?.data;

    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      return false;
    }

    if (payload?.success === false) {
      return true;
    }

    if (
      typeof payload?.status === "number" &&
      payload.status >= 400
    ) {
      return true;
    }

    if (
      typeof payload?.status === "number" &&
      payload.status === 206 &&
      payload?.success === false
    ) {
      return true;
    }

    return false;
  };
  const hasExplicitSuccessPayload = (response) => {
    const payload = response?.data;

    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
      return false;
    }

    if (payload?.success === true || payload?.status === true) {
      return true;
    }

    if (
      typeof payload?.status === "number" &&
      payload.status >= 200 &&
      payload.status < 300 &&
      payload?.success !== false
    ) {
      return true;
    }

    return false;
  };

  let baseURL = handleGetEndPoint(end_point);
  let url = `${baseURL}${apiUrl}`;
  const shouldSendJsonContentType =
    method !== "GET" && method !== "DELETE" && isFile !== "file";
  const baseHeaders = {
    ...(shouldSendJsonContentType ? { "Content-Type": "application/json" } : {}),
    ...(isFile === "file" ? { "Content-Type": "multipart/form-data" } : {}),
  };
  let header = {
    headers: baseHeaders,
  };
  const token = localStorage.getItem("accessToken");
  let networkErrMsg = "";

  if (token) {
    header = {
      headers: {
        Authorization: `Bearer ${token}`,
        ...baseHeaders,
      },
    };
  }
  if (end_point === "CHAT" && !token) {
    header = {
      headers: {
        Authorization: "",
        ...baseHeaders,
      },
    };
  }
  // else {
  //   header = {
  //     headers: {
  //       "Sec-Fetch-Mode":"cors",
  //       "Content-Type":
  //         isFile === "file" ? "multipart/form-data" : "application/json",
  //     },
  //   };
  // }
  let la_body = {};
  if (body instanceof FormData && isFile === "file") {
    la_body = prepareMultipartData(body, end_point);
  } else if (body && isFile !== "file") {
    let string_data = JSON.stringify(body);
    la_body = {
      data:
        end_point === "CHAT"
          ? encryptJsonDataPython(string_data)
          : encryptJsonDataNode(string_data),
    };
  }
  // console.log("la_dsdsa", la_body);
  return new Promise(async (resolve, reject) => {
    try {
      if (isFile == "link") {
        const file = await fetch(url, header)
          .then((res) => res.blob())
          .then((data) => new File([data], "invoice", { type: data.type }));
        resolve({
          status: true,
          file,
        });
      } else {
        if (method === "POST") {
          axios
            .post(url, body, header)
            .then((response) => {
              // let response=decryptDataLocal(res) //sample of decryption
              if (
                (isSuccessfulHttpResponse(response) &&
                  !hasExplicitFailurePayload(response)) ||
                hasExplicitSuccessPayload(response) ||
                response.statusText == "OK"
              ) {
                resolve({
                  status: true,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              } else {
                resolve({
                  status: false,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              }
            })
            .catch((err) => {
              networkErrMsg = networkErr(err, end_point);
              errHandling(err, showDefaultError, end_point);

              resolve({
                status: false,
                msg:
                  err?.response?.data?.message ||
                  err?.response?.data?.msg ||
                  networkErrMsg,
                reason: err?.response?.data?.reason,
              });
            });
        }
        if (method === "PUT") {
          axios
            .put(url, body, header)
            .then((response) => {
              if (
                (isSuccessfulHttpResponse(response) &&
                  !hasExplicitFailurePayload(response)) ||
                hasExplicitSuccessPayload(response) ||
                response.statusText == "OK"
              ) {
                resolve({
                  status: true,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              } else {
                resolve({
                  status: false,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              }
            })
            .catch((err) => {
              networkErrMsg = networkErr(err);
              errHandling(err, showDefaultError, end_point);

              resolve({
                status: false,
                msg: err?.response?.data?.message || networkErrMsg,
                reason: err?.response?.data?.reason,
              });
            });
        }
        if (method === "PATCH") {
          axios
            .patch(url, body, header)
            .then((response) => {
              if (
                (isSuccessfulHttpResponse(response) &&
                  !hasExplicitFailurePayload(response)) ||
                hasExplicitSuccessPayload(response) ||
                response.statusText == "OK"
              ) {
                resolve({
                  status: true,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              } else {
                resolve({
                  status: false,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              }
            })
            .catch((err) => {
              networkErrMsg = networkErr(err, end_point);
              errHandling(err, showDefaultError, end_point);

              resolve({
                status: false,
                msg: err?.response?.data?.message || networkErrMsg,
              });
            });
        }
        if (method === "GET") {
          axios
            .get(url, header)
            .then((response) => {
              if (
                (isSuccessfulHttpResponse(response) &&
                  !hasExplicitFailurePayload(response)) ||
                hasExplicitSuccessPayload(response) ||
                response.statusText == "OK"
              ) {
                resolve({
                  status: true,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              } else {
                resolve({
                  status: false,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              }
            })
            .catch((err) => {
              networkErrMsg = networkErr(err, end_point);
              errHandling(err, showDefaultError, end_point);

              resolve({
                status: false,
                msg: err?.response?.data?.message || networkErrMsg,
              });
            });
        }
        if (method === "DELETE") {
          if (body) {
            header = { ...header, data: body };
          }
          axios
            .delete(url, header)
            .then((response) => {
              if (
                (isSuccessfulHttpResponse(response) &&
                  !hasExplicitFailurePayload(response)) ||
                hasExplicitSuccessPayload(response) ||
                response.statusText == "OK"
              ) {
                resolve({
                  status: true,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              } else {
                resolve({
                  status: false,
                  res: response,
                  msg: response?.data?.msg || response?.data?.message,
                });
              }
            })
            .catch((err) => {
              networkErrMsg = networkErr(err, end_point);
              errHandling(err, showDefaultError, end_point);

              resolve({
                status: false,
                msg: err?.response?.data?.message || networkErrMsg,
              });
            });
        }
      }
    } catch (err) {
      networkErrMsg = networkErr(err);
      reject(err.response);
    }
  });
}

function handleGetEndPoint(end_point) {
  switch (end_point) {
    case "SUBSCRIPTION": {
      // return process.env.REACT_APP_SUBSCRIPTION_API_END_POINT; /*for conditional razor pay and stripe payment gateway*/
      return process.env.REACT_APP_SUBSCRIPTION_API_END_POINT_OTHERS;
    }
    case "SUBSCRIPTION_IN": {
      // return process.env.REACT_APP_SUBSCRIPTION_API_END_POINT; /*for conditional razor pay and stripe payment gateway*/
      return process.env.REACT_APP_SUBSCRIPTION_API_END_POINT_OTHERS;
    }
    case "SUBSCRIPTION_OTHERS": {
      return process.env.REACT_APP_SUBSCRIPTION_API_END_POINT_OTHERS;
    }
    case "USER": {
      return process.env.REACT_APP_USER_API_END_POINT;
    }
    case "CHAT": {
      return process.env.REACT_APP_CHAT_BASE_URL;
    }
    // case 'PRODUCT': {
    //   return process.env.REACT_APP_BOT_API_END_POINT
    // }
    // default: {
    //   return process.env.REACT_APP_BOT_API_END_POINT
    // }
  }
}

const errStatusCode = [401, 403]; //403-for inactive user and 401 is for unauthorised user

function networkErr(error, end_point = "") {
  if (error.code === "ERR_NETWORK") {
    return "Network Error ❌: No internet connection.";
  } else if (end_point == "CHAT") {
    return error.response.data.error;
  } else if (error.response) {
    return `Server Error: ${error.response.status}`;
  } else {
    return ("Request Failed:", error.message);
  }
}

function errHandling(err, showDefaultError = true, end_point = "") {
  if (errStatusCode.includes(err.status) && end_point != "CHAT") {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("botModification");
    localStorage.removeItem("botStyle");
    localStorage.removeItem("botWorkFlowEdge");
    localStorage.removeItem("botWorkFlowNode");
    localStorage.removeItem("chatElement");
    localStorage.removeItem("chatNode");
    setTimeout(() => {
      // window.location.reload();
    }, 2000);
  }

  showDefaultError &&
    !err?.response?.data?.reason &&
    showToast(
      err?.response?.data?.message ||
        err?.response?.data?.msg ||
        err?.response?.data?.error ||
        (err?.response?.data?.error?.message &&
          (typeof err?.response?.data?.error?.message == "string"
            ? err?.response?.data?.error?.message
            : err?.response?.data?.error?.message[0])) ||
        "Somthing went wrong",
      LABEL.TOAST_TYPE.ERROR,
    );
}
function prepareMultipartData(originalFormData, end_point) {
  const dataObject = {};
  const files = {};

  for (const [key, value] of originalFormData.entries()) {
    if (value instanceof File) {
      files[key] = value;
    } else {
      dataObject[key] = value;
    }
  }
  let string_data = JSON.stringify(dataObject);
  const encryptedData =
    end_point === "CHAT"
      ? encryptJsonDataPython(string_data)
      : encryptJsonDataNode(string_data);
  const newFormData = new FormData();
  newFormData.append("data", encryptedData);
  for (const key in files) {
    newFormData.append(key, files[key]);
  }
  return newFormData;
}
function decryptDataLocal(originaldata, end_point) {
  let result =
    end_point === "CHAT"
      ? decryptJsonDataPython(originaldata.data)
      : decryptJsonDataNode(originaldata?.data);
  return result;
}
